import React from "react";
import styles from "./VerticalFlexContainer.module.css";

const VerticalFlexContainer: React.FC<FlexContainer> = ({
  children,
  className,
  onClick,
  ...props
}) => {
  return (
    <div
      className={[styles.container, className ?? ""].join(" ")}
      style={props}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default VerticalFlexContainer;
